import moment from 'moment-timezone';

function isValidTimeZone(tz) {
  let isValid = false;
  try {
    const isValidZone = moment.tz.zone(tz);
    if (isValidZone) {
      isValid = true;
    }
  } catch (e) {
    console.error(e, 'unable to parse timeZone', tz);
  }
  return isValid;
}

export function getFormattedDateFromMillis(millis, format, timeZone) {
  if (isValidTimeZone(timeZone)) {
    return moment.tz(millis, timeZone).format(format);
  }
  return moment(millis).format(format);
}

export function getMillisFromDateString(date, format, timeZone) {
  if (isValidTimeZone(timeZone)) {
    return moment.tz(date, format, timeZone).valueOf();
  }
  return moment(date, format).valueOf();
}
